<form>
	<table class="table table-sm table-dark no-bottom-margin" [ngClass]="{ 'bp-print-view': printView}">
		<tbody>
			<tr>
				<th colspan="12">G-/S-Horizonte</th>
			</tr>
			<tr>
				<th colspan="1">Go</th>
				<td colspan="1"><wd-text name="Go" [(model)]="bp.extendedHeader.gHorizont.go"></wd-text></td>
				<th colspan="1">Gr</th>
				<td colspan="1"><wd-text name="Gr" [(model)]="bp.extendedHeader.gHorizont.gr"></wd-text></td>
				<th colspan="1">G</th>
				<td colspan="1"><wd-text name="G" [(model)]="bp.extendedHeader.gHorizont.g"></wd-text></td>
				<th colspan="1">Sw</th>
				<td colspan="1"><wd-text name="Sw" [(model)]="bp.extendedHeader.sHorizont.sw"></wd-text></td>
				<th colspan="1">Sd</th>
				<td colspan="1"><wd-text name="Sd" [(model)]="bp.extendedHeader.sHorizont.sd"></wd-text></td>
				<th colspan="1">S</th>
				<td colspan="1"><wd-text name="S" [(model)]="bp.extendedHeader.sHorizont.s"></wd-text></td>
			</tr>
		</tbody>
	</table>
</form>
